import React, { type FormEvent, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Button } from '../../../../components/Button/Button'
import { isValidUrl } from '../../../../common/urlValidation'
import { type AppDetailsFormData, AppDetailsFormFields } from '../../components/AppDetailsFormFields'
import { SHORT_DESCRIPTION_MAX } from '../../constants'

interface AppDetailsStepProps {
  initialData: AppDetailsFormData
  onNext: (data: AppDetailsFormData) => void
  onCancel: () => void
}

export const AppDetailsStep: React.FC<AppDetailsStepProps> = ({ initialData, onNext, onCancel }) => {
  const [formData, setFormData] = useState<AppDetailsFormData>(initialData)
  const [validated, setValidated] = useState(false)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setValidated(true)

    if (!formData.name.trim() || !formData.shortDescription.trim()) {
      return
    }

    if (formData.shortDescription.length > SHORT_DESCRIPTION_MAX) {
      return
    }

    if (formData.imageUrl.trim() !== '' && !isValidUrl(formData.imageUrl)) {
      return
    }

    onNext(formData)
  }

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <h5 className='fw-bold mb-4'>Enter app details</h5>

      <AppDetailsFormFields formData={formData} setFormData={setFormData} validated={validated} />

      <div className='d-flex justify-content-end gap-3 mt-4'>
        <Button variant='secondary' className='fw-bold' onClick={onCancel}>
          Cancel
        </Button>
        <Button type='submit' variant='primary' className='fw-bold'>
          Next
        </Button>
      </div>
    </Form>
  )
}
